import React, { useEffect, useState } from "react";
import { TailSpin } from "react-loader-spinner";
import { Link, useLocation } from "react-router-dom";

const DashboardSidebar = ({ handleNext }) => {
  const [steps, setSteps] = useState({
    step1: "",
    step2: "",
    step3: "",
    step4: "",
  });
  const [isFinal, setIsfinal] = useState(false);
  const location = useLocation();

  const path = location?.pathname;

  useEffect(() => {
    switch (path) {
      case "/upload-document":
        setSteps({
          step1: "current",
          step2: "upcoming",
          step3: "upcoming",
          step4: "upcoming",
        });
        break;

      case "/document-privacy":
        setSteps({
          step1: "done",
          step2: "current",
          step3: "upcoming",
          step4: "upcoming",
        });
        break;

      case "/issuer":
        setSteps({
          step1: "done",
          step2: "done",
          step3: "current",
          step4: "upcoming",
        });
        break;

      case "/final-submit":
        setSteps({
          step1: "done",
          step2: "done",
          step3: "done",
          step4: "current",
        });
        setIsfinal(true);
        break;

      default:
        break;
    }
  }, [path]);

  return (
    <>
      <div className="radial-divider"></div>
      <div className="grid-side-section__right">
        <div className="right-steps">
          <div
            className={`blurred-widget-block bdr-gray steps steps--${steps?.step1}`}
          >
            <Link to="#" className="w-100 btn blur-2 bdrs10 steps__clickable">
              <div className="grayText fz10 text-uppercase fw500 num">
                Step 1
              </div>
              <h6 className="w-100 mb-0 text-capitalize fw800 fz18 font-secondary">
                <span>Upload your Document</span>
                <img src="/images/icons/icon-sparkling-tickmark.svg" alt="" />
              </h6>
            </Link>

            <p className="mb-0 fz12 text-capitalize grayText">
              You can upload your file or folders to verify...
            </p>
          </div>

          <div
            className={`blurred-widget-block bdr-gray steps steps--${steps?.step2}`}
          >
            <Link to="#" className="w-100 btn blur-2 bdrs10 steps__clickable">
              <div className="grayText fz10 text-uppercase fw500 num">
                Step 2
              </div>
              <h6 className="w-100 mb-0 text-capitalize fw800 fz18 font-secondary">
                <span>Privacy Settings</span>
                <img src="/images/icons/icon-sparkling-tickmark.svg" alt="" />
              </h6>
            </Link>

            <p className="mb-0 fz12 text-capitalize grayText">
              Set your folders privacy and other settings for later use. you can
              set folders and separate files settings by you will.
            </p>
          </div>

          {path === "/issuer" || path === "/final-submit" ? (
            <>
              {" "}
              <div
                className={`blurred-widget-block bdr-gray steps steps--${steps?.step3}`}
              >
                <Link
                  to="#"
                  className="w-100 btn blur-2 bdrs10 steps__clickable"
                >
                  <div className="grayText fz10 text-uppercase fw500 num">
                    Step 3
                  </div>
                  <h6 className="w-100 mb-0 text-capitalize fw800 fz18 font-secondary">
                    <span>Generate</span>
                    <img
                      src="/images/icons/icon-sparkling-tickmark.svg"
                      alt=""
                    />
                  </h6>
                </Link>

                <p className="mb-0 fz12 text-capitalize grayText">
                  Set your folders privacy and other settings for later use. you
                  can set folders and separate files settings by you will.
                </p>
              </div>
              <div
                className={`blurred-widget-block bdr-gray steps steps--${steps?.step4}`}
              >
                <Link
                  to="#"
                  className="w-100 btn blur-2 bdrs10 steps__clickable"
                >
                  <div className="grayText fz10 text-uppercase fw500 num">
                    Step 4
                  </div>
                  <h6 className="w-100 mb-0 text-capitalize fw800 fz18 font-secondary">
                    <span>Final Submit</span>
                    <img
                      src="/images/icons/icon-sparkling-tickmark.svg"
                      alt=""
                    />
                  </h6>
                </Link>

                <p className="mb-0 fz12 text-capitalize grayText">
                  Set your folders privacy and other settings for later use. you
                  can set folders and separate files settings by you will.
                </p>
              </div>{" "}
            </>
          ) : path === "/document-preview" ? (
            <div
              className={`blurred-widget-block bdr-gray steps steps--${steps?.step4}`}
            >
              <Link to="#" className="w-100 btn blur-2 bdrs10 steps__clickable">
                <div className="grayText fz10 text-uppercase fw500 num">
                  Step 4
                </div>
                <h6 className="w-100 mb-0 text-capitalize fw800 fz18 font-secondary">
                  <span>Final Submit</span>
                  <img src="/images/icons/icon-sparkling-tickmark.svg" alt="" />
                </h6>
              </Link>

              <p className="mb-0 fz12 text-capitalize grayText">
                Set your folders privacy and other settings for later use. you
                can set folders and separate files settings by you will.
              </p>
            </div>
          ) : (
            <span></span>
          )}

          <div className="loader-wrapper px-5 mx-5"></div>
          <button
            className="text-uppercase bdrs10 fw600 fz10 btn btn-solid btn-solid--dark"
            onClick={handleNext}
          >
            {isFinal ? "Submit" : "Next"}
          </button>
        </div>
      </div>
    </>
  );
};

export default DashboardSidebar;
